<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditBank"
        class="bg-black fixed h-screen bg-opacity-70 inset-0 z-50 w-full"
      >
        <form
          @submit.prevent="editBankDetail"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full overflow-y-auto"
          style="height: auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-50 w-full"
            >
              <Loader class="center-h-v" />
            </div>
          </transition>

          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Add Bank Details</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="p-4 grid grid-cols-2 gap-4">
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Bank Name</label>
                <!-- {{ info }} -->
                <select
                  v-model="info.BankName"
                  required
                  class="p-2 bg-gray-200 rounded-md w-full"
                >
                  <option value="" disabled selected>Select Bank</option>
                  <option v-for="bank in banks" :value="bank" :key="bank">
                    {{ bank }}
                  </option>
                  <!-- Additional option for user to enter their own bank name -->
                  <option value="other">Other</option>
                </select>
                <!-- Show an input field if the user selects "Other" -->
                <input
                  v-if="info.BankName === 'other'"
                  v-model="customBankName"
                  class="mt-2 p-2 bg-gray-200 rounded-md w-full"
                  placeholder="Enter Bank Name"
                />
              </div>
            </div>

            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Account Name</label>
                <input
                  v-model="info.AccountName"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Account Number</label>
                <input
                  v-model="info.AccountNumber"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Branch</label>
                <input
                  v-model="info.Branch"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Branch Code</label>
                <input
                  v-model="info.BranchCode"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
            <div class="text-sm col-span-1">
              <div class="">
                <label class="block pb-1">Swift Code</label>
                <input
                  v-model="info.SwiftCode"
                  required
                  type="text"
                  class="p-2 bg-gray-200 rounded-md w-full"
                />
              </div>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-md px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { kenyanBanks } from "@/utils/utilsData";
import Loader from "@/components/loader/loader.vue";
import decryptData from "@/utils/decrypt";

export default {
  name: "EditBank",
  props: ["showEditBank", "reload", "data"],
  components: { Loader },
  data() {
    return {
      decryptDataLocal: decryptData,

      banks: [],
      loading: false,
      create_success: null,
      create_error: null,
      display: false,
      showStatus: false,
      info: {},

      customBankName: "", // To store the custom bank name entered by the user
    };
  },
  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },
  created() {},

  watch: {
    data: {
      // This function will run whenever 'data' prop changes
      handler(newData) {
        // Set form fields with the new data
        if (newData && newData.length > 0 && newData[0].info) {
          newData[0].info.forEach((item) => {
            if (item.name && item.value) {
              const propertyName = item.name.replace(/\s+/g, "");
              this.info[propertyName] = decryptData(
                item.value,
                this.$decryptionKey
              );
            }
          });
          // Manually trigger a re-render to update the view with the new data
          this.$forceUpdate();
        }
      },
      // Deep is set to true to watch for changes inside the 'data' array
      deep: true,
    },

    showEditBank(newInfo) {
      if (newInfo) {
        this.banks = kenyanBanks;
        if (this.data && this.data.length > 0 && this.data[0].info) {
          this.data[0].info.forEach((item) => {
            if (item.name && item.value) {
              if (item.name == "Name") {
                this.info["BankName"] = decryptData(
                  item.value,
                  this.$decryptionKey
                );
              }
              const propertyName = item.name.replace(/\s+/g, "");
              this.info[propertyName] = decryptData(
                item.value,
                this.$decryptionKey
              );
            }
          });
        }
      }
    },
  },

  methods: {
    setFormFields(newInfo) {
      // Update the form fields with the new values from 'info'
      this.info.BankName = this.info.Name || "";
      this.info.AccountName = newInfo.AccountName || "";
      this.info.AccountNumber = newInfo.AccountNumber || "";
      this.info.Branch = newInfo.Branch || "";
      this.info.BranchCode = newInfo.BranchCode || "";
      this.info.SwiftCode = newInfo.SwiftCode || "";
    },
    close() {
      this.$emit("close");
    },
    handleSubmit() {
      setTimeout(() => {
        this.close();
      }, 1000);
    },
    editBankDetail() {
      this.info.EmployeeId = this.getCurrentEmployeeId;
      this.loading = true;

      if (this.customBankName) {
        this.info.BankName = this.customBankName;
      }
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/bank/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;

              this.reload();

              this.info = {
                EmployeeId: this.getCurrentEmployeeId,
                BankName: "",
                AccountName: "",
                AccountNumber: "",
                Branch: "",
                BranchCode: "",
                SwiftCode: "",
              };

              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
/* ... Rest of the styles ... */
</style>
